import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useAssistant } from "./assistant-context";

function shortcutLabel(): string {
  if (typeof navigator === "undefined") return "Ctrl+J";
  const platform = (navigator as any).userAgentData?.platform || navigator.platform || "";
  return /mac|iphone|ipad/i.test(platform) ? "⌘J" : "Ctrl+J";
}

export default function AssistantLauncher() {
  const { available, open, toggle, isStreaming } = useAssistant();
  if (!available) return null;
  const label = `Ask Claude (${shortcutLabel()})`;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={toggle}
            aria-label={label}
            aria-pressed={open}
            className={cn(
              "relative flex h-9 w-9 items-center justify-center rounded-md border border-input bg-background text-foreground transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              open && "bg-accent",
            )}
          >
            <Sparkles className="h-4 w-4" />
            {isStreaming && !open && (
              <span className="absolute right-1 top-1 h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-500" />
            )}
          </button>
        </TooltipTrigger>
        <TooltipContent side="bottom">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
